module.exports = __webpack_public_path__ + "static/hero-video-bg-f90943d24ec61eff546fcb2416cb4045.jpg";